import AppBaseComponent from "../../../components/AppBaseComponent";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import React from "react";

class TrainingWidget extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.state                      =   {
            loading                     :      false,
            data                        :       null,
        }
    }

    componentDidMount() {
        
        this.getTrainingListing()
        
    }

    getTrainingListing                =   (reload=false)  =>  {
        this.setState({loading: true});
        HttpAPICall.withAthorization('GET',process.env.REACT_APP_SERVER_PATH + '/backoffice/dashboard/training', this.props.access_token,{}, {} , (response) => {
            this.setState({data : response.data.data}) 
        }).then(() => this.setState({loading: false}));
    }

    render                      =   ()  =>  {
    
        let pending_obj             =   {'search_status' : this.state.data && this.state.data.total_pending ? 5 : 0};
        let allocated_obj           =   {'search_status' : this.state.data && this.state.data.total_allocated ? 11 : 0};
        return (<div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color">Training</h6>
                    </div>
                    <div className="col-3">

                    </div>
                    <div className="col-3 p0">

                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-2 btn btn-light btn-block" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => this.getTrainingListing()}>Refresh</li>
                        </ul>
                    </div>
                </div>
                <div className="row mt-2 align-items-center">

                    <div className="col-12">
                        <table className="table table-hover table-bordered table-borderless bg-white my-2">
                            <thead className="table-secondary">
                                <tr className="text-end">
                                    <th className="text-start" ></th>
                                    <th style={{ width: "25%" }} className="text-center"></th>

                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading
                                    ? (<tr><td colSpan="2"><Loader /></td></tr>)
                                    :
                                    this.state.data ? <Ax>
                                        <tr>
                                            <td>Total Pending</td>
                                            <th className="text-center"><Link to={{pathname: "/training_list" , search: "?" + new URLSearchParams(pending_obj).toString() }}>{this.state.data && this.state.data.total_pending ? this.state.data.total_pending : ""}</Link></th>
                                        </tr>
                                        <tr>
                                            <td>Total Allocated</td>
                                            <th className="text-center"><Link to={{pathname: "/training_list" , search: "?" + new URLSearchParams(allocated_obj).toString() }}>{this.state.data && this.state.data.total_allocated ? this.state.data.total_allocated : ""}</Link></th>
                                        </tr>
                                    </Ax>

                                        : <tr><td className="text-center" colSpan={2}>No Record Found</td></tr>
                                }


                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
    };
};


export default connect(mapStateToProps)(TrainingWidget);